function Spinner(): JSX.Element {
  return (
    <div className="container">
      <h1 className="page-content__title title title--bigger">LOADING...</h1>
    </div>
  );
}

export default Spinner;
